import * as React from "react";

import "./no-enrollment.scss";

import {ReactGASCEnrollment} from "@Common/libs/ga/xd-react-ga";
import {cs}                  from "@Common/react/chain-services";
import {fragments}           from "@Common/react/fragments";
import {Invoke}              from "@Common/react/invoke";
import {Static}              from "@Common/react/static";
import {Static2}             from "@Common/react/static-2";
import {Responsive2}         from "@Common/ui-components/responsive-2";
import {chain}               from "@Common/utils/fs";
import {parseUrlQuery}       from "@Common/utils/parse-url-query";
import {selectRandom}        from "@Common/utils/random";

import {saveStepUrl}  from "../common/save-step-url";
import {urlStepNames} from "../common/url-step-names";
import {SetupModal}   from "../setup-modal/setup-modal";

import {VideoAutoplay} from "./video-autoplay";

export const NoEnrollment = (
    {
        enrollment, initStep, agentId, branchId, program, getStyleTemplate,
        saveEnrollment,
        next: rootNext,
    }
) => cs(
    ["block", (_, next) => Static2({next})],
    ({block}, next) => rootNext({
        navBlock: {
            block: () => block.get()?.(),
        },
        render: () => next(),
    }),


    ["initStep", (_, next) => next(chain(
        urlStepNames.indexOf(initStep),
        (_) => _ !== -1 ? _ : initStep === "reenroll" ? 0 : null,
    ))],
    ["setupModal", ({initStep, block}, next) => SetupModal({
        enrollment, agentId, branchId, program,
        ...initStep!=null && {
            initShow: {
                tab: initStep,
                label: parseUrlQuery(location.search)?.label,
            },
        },
        setNavBlock: block.set,
        saveEnrollment: async (newValue, {newEnrollment=undefined, params=undefined, ...options}={}) => {
            if (newEnrollment) {
                ReactGASCEnrollment({
                    eventName: "enroll",
                    idProgram: program.idProgram,
                    data: {
                        label: params?.label,
                        source: "direct",
                    },
                });
            } else {
                ReactGASCEnrollment({
                    eventName: "modify_enrollment",
                    idProgram: program.idProgram,
                });
            }

            return await saveEnrollment(newValue, {newEnrollment, ...options});
        },
        onShowImportingPage: ({label}) => saveStepUrl("reenroll", {label}),
        onShowStep: (stepIndex, {label}) => saveStepUrl(urlStepNames[stepIndex], {label}),
        getStyleTemplate,
        next,
    })],
    ({}, next) => fragments(
        next(),
        Invoke({
            action: () => {
                saveStepUrl("landing");
            },
        })
    ),

    ["responsive", (_, next) => Responsive2({
        translate: (w) => w < 768 ? "mobile" : "desktop",
        next,
    })],
    ({setupModal, responsive}) => (
        <div className="no-enrollment-280">

            <div className="landing-content">
                {responsive === "desktop" && program?.programPreferences?.bannerImageDesktop && (
                    renderImg({
                        src: program.programPreferences.bannerImageDesktop,
                        className: "banner",

                        "xd-qa-type": "image",
                        "xd-qa-name": "Banner for desktop",
                    })
                )}
                {responsive === "mobile" && program?.programPreferences?.bannerImageMobile && (
                    renderImg({
                        src: program.programPreferences.bannerImageMobile,
                        className: "banner",

                        "xd-qa-type": "image",
                        "xd-qa-name": "Banner for mobile",
                    })
                )}

                <div className="dual-panel">
                    <div {...{
                        className: "html",
                        dangerouslySetInnerHTML: {__html: program?.programPreferences?.landingPageContent},

                        "xd-qa-type": "text",
                        "xd-qa-name": "Landing Page Content",
                    }}/>

                    {responsive === "desktop" && program?.programPreferences?.productImageDesktop && (
                        <div className="product-image">
                            {renderImg({
                                src: program.programPreferences.productImageDesktop,
                                className: "img",

                                "xd-qa-type": "image",
                                "xd-qa-name": "Product image",
                            })}
                        </div>
                    )}

                </div>

            </div>

            {/*{Banner({*/}
            {/*    program,*/}
            {/*})}*/}
            {/*{Features({*/}
            {/*    program,*/}
            {/*    // domRef: featuresHeight.ref,*/}
            {/*})}*/}

            <div className="action">
                {cs(
                    ["newEnrollLabel", (_, next) => Static({
                        getInitValue: () => selectRandom([
                            "ENROLL NOW",
                            "VIEW CAMPAIGN OPTIONS",
                            "SELECT EDITIONS",
                            "BUILD CAMPAIGN",
                        ]),
                        next,
                    })],
                    ["label", ({newEnrollLabel}, next) => next(
                        !enrollment ? (
                            newEnrollLabel
                        ) : (
                            "CONTINUE ENROLLMENT"
                        )
                    )],
                    ({label}) => (
                        <button {...{
                            onClick: () => {
                                ReactGASCEnrollment({
                                    eventName: "start_enrollment",
                                    idProgram: program.idProgram,
                                    data: {
                                        label,
                                        source: "direct",
                                    },
                                });

                                setupModal.show({
                                    label,
                                });
                            },

                            "xd-qa-type": "button",
                            "xd-qa-name": "Enroll",
                        }}>
                            {label}
                        </button>
                    )
                )}
            </div>

        </div>
    ),
);

const renderImg = ({src, className, ...props}) => {
    if (src.toLowerCase().endsWith(".mp4")) {
        return cs(
            ["videoAutoplay", (_, next) => VideoAutoplay({next})],
            ({videoAutoplay}) => (
                <video {...{
                    className: className,
                    src: src,
                    ref: videoAutoplay.ref,
                    ...props,
                }}/>
            )
        );
    } else {
        return (
            <img {...{
                className: className,
                src: src,
                ...props,
            }}/>
        )
    }
};

